import * as React from 'react';
import { getFormatDateFromStoreDate } from 'shared-components';
import { Section } from '../../../../Finger/Section';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../../utilities/documents';
import FingerWithApprove from '../../../../atoms/finger-with-approve';
import NoDocuments from '../../../../atoms/no-doc-placeholder';

import { UserRole } from '../../../../../store/auth/types';
import { SummaryRow } from '../../../../Summary/SummaryRow';
import { DocAccessType, IFollowUpDocuments, TravelTicketDocList } from '../../../../../types';

interface IProps {
  userAccess?: DocAccessType;
  documents: IFollowUpDocuments['beforeTravel']['travelTicket'];
  userRole?: UserRole;

  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;

  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}
const TravelTicket = (props: IProps) => {
  const { documents: travelTicketDocs, userAccess, userRole } = props;

  const visibleDocs = getVisible({ documentsHash: travelTicketDocs, userAccess, userRole });

  const hasDocs = visibleDocs.length > 0;
  const hasDeletedDocs = hasDeleted(travelTicketDocs);

  const docNodes: React.ReactNode[] = [];

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if (userAccess && !hasDocs) {
    return null;
  }

  if (hasDocs) {
    docNodes.push(
      ...visibleDocs.map((travelTicket: TravelTicketDocList, travelTicketIndex: number) => {
        const { key: docKey, item } = travelTicket;

        return (
          <FingerWithApprove
            id={`travel-ticket-${docKey}`}
            key={`travel-ticket-${docKey}`}
            status={getFingerStatus(item)}
            isProcessingPdf={item.isProcessingPdf}
            reason={item.reason}
            fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
            fileNames={item.fileNames}
            label={`Travel Ticket or Booking for ${getFormatDateFromStoreDate(item.date)} ${
              Object.keys(travelTicketDocs ?? {}).length > 1 ? (travelTicketIndex > 0 ? travelTicketIndex + 1 : '') : ''
            }`}
            canUpload={props.canUpload}
            canOpen={props.canOpen}
            canApprove={props.canApprove}
            canReject={props.canReject}
            isDeleting={props.isDeleting}
            canAcknowledge={false}
            onUploadClick={() => {
              props.onUploadClick(docKey);
            }}
            onOpenClick={() => {
              props.onOpenClick(docKey);
            }}
            onApproveClick={() => {
              props.onApproveClick(docKey);
            }}
            onRejectClick={() => {
              props.onRejectClick(docKey);
            }}
            onRescindRejectClick={() => {
              props.onRescindRejectClick(docKey);
            }}
            onDeleteClick={() => {
              props.onDeleteClick(docKey);
            }}
            onAcknowledgeClick={() => {}}
            userRole={props.userRole}
            deletedByTTL={item.deletedByTTL}
          >
            <SummaryRow
              key={`travel-ticket-flight-number-${docKey}`}
              label="Flight number"
              fullLabel="What is the flight number?"
              value={item.flightNumber}
            />
          </FingerWithApprove>
        );
      }),
    );
  }

  return (
    <>
      <Section
        key={`before-travel`}
        label={'Scan of document showing the details of UK travel'}
        canEdit={false}
        warning={''}
      >
        {hasDocs ? docNodes : <NoDocuments />}
      </Section>
    </>
  );
};

export default TravelTicket;
